import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
import { t } from "i18next";
import { isEqual } from "lodash";
import { useEffect, useState } from "react";
import { trackEvent } from "../../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../../utils/mixpanelEvents";
import usePatientBulkTaggingService from "../../../PatientTags/services/patientBulkTaggingService";
import Toast from "../../../Toast";
import { mapApiReportToCardData } from "./mapReport";
export var useApplyReportTag = function useApplyReportTag(_ref) {
  var patientId = _ref.patientId,
    _ref$patientTags = _ref.patientTags,
    patientTags = _ref$patientTags === void 0 ? [] : _ref$patientTags,
    onApplied = _ref.onApplied;
  var bulkTagging = usePatientBulkTaggingService(patientId);
  var _useState = useState(null),
    applyingTagId = _useState[0],
    setApplyingTagId = _useState[1];
  var _useState2 = useState(new Map()),
    appliedTags = _useState2[0],
    setAppliedTags = _useState2[1];

  // Drop the optimistic override only once patientTags reflects the exact value
  // we applied (matching tag_id AND response, e.g. via the update_patient
  // websocket). Keeping it keyed on the applied response means changing an
  // existing tag's value stays selected until the server confirms, while a
  // value that differs server-side reads as unselected via derived `applied`.
  useEffect(function () {
    setAppliedTags(function (prev) {
      if (prev.size === 0) return prev;
      var next = new Map(prev);
      prev.forEach(function (response, id) {
        var confirmed = patientTags.some(function (pt) {
          return String(pt.tag_id) === id && isEqual(pt.response, response);
        });
        if (confirmed) next["delete"](id);
      });
      return next.size === prev.size ? prev : next;
    });
  }, [patientTags]);
  var isOptimisticallyApplied = function isOptimisticallyApplied(tag) {
    return appliedTags.has(tag.id) && isEqual(appliedTags.get(tag.id), tag.response);
  };
  var onApplyTag = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(tag) {
      var _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            if (!(tag.tagId == null || tag.applied || isOptimisticallyApplied(tag) || applyingTagId)) {
              _context.n = 1;
              break;
            }
            return _context.a(2);
          case 1:
            setApplyingTagId(tag.id);
            _context.p = 2;
            _context.n = 3;
            return bulkTagging.mutateAsync({
              updated_tags: [{
                tag_id: tag.tagId,
                response: tag.response
              }],
              deleted_tags: []
            });
          case 3:
            setAppliedTags(function (prev) {
              return new Map(prev).set(tag.id, tag.response);
            });
            trackEvent(MIXPANEL_EVENTS.RADIOLOGY_REPORT_TAG_APPLIED, {
              label: tag.label,
              value: tag.type
            });
            Toast.success(t("message.tag_saved_successfully"));
            onApplied === null || onApplied === void 0 || onApplied();
            _context.n = 5;
            break;
          case 4:
            _context.p = 4;
            _t = _context.v;
            Toast.error(t("message.error_saving_tag"));
          case 5:
            _context.p = 5;
            setApplyingTagId(null);
            return _context.f(5);
          case 6:
            return _context.a(2);
        }
      }, _callee, null, [[2, 4, 5, 6]]);
    }));
    return function onApplyTag(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  var withAppliedState = function withAppliedState(tags) {
    return tags.map(function (tag) {
      return !tag.applied && isOptimisticallyApplied(tag) ? _objectSpread(_objectSpread({}, tag), {}, {
        applied: true
      }) : tag;
    });
  };
  var buildCardData = function buildCardData(report) {
    var customFields = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var tags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
    var data = mapApiReportToCardData(report, customFields, tags);
    return _objectSpread(_objectSpread({}, data), {}, {
      patientUid: patientId != null ? Number(patientId) : undefined,
      versions: data.versions.map(function (version) {
        return _objectSpread(_objectSpread({}, version), {}, {
          aiTags: withAppliedState(version.aiTags)
        });
      })
    });
  };
  return {
    onApplyTag: onApplyTag,
    applyingTagId: applyingTagId,
    buildCardData: buildCardData
  };
};
export default useApplyReportTag;